import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TokenHandler from './components/TokenHandler';
import Lobby from './pages/Lobby';
import Room from './pages/Room';
import { UserProvider } from './components/UserContext';
import ProtectedRoute from './components/ProtectedRoute';
import './index.css';

function App() {
  return (
    <Router>
      <UserProvider>
        <TokenHandler />
        <Routes>
          <Route path="/" element={<Lobby />} />
          <Route
            path="/room/:roomId/*"
            element={
              <ProtectedRoute>
                <Room />
              </ProtectedRoute>
            }
          />
        </Routes>
      </UserProvider>
    </Router>
  );
}


export default App;
